import React from 'react';
import { Card, Typography } from 'antd';
import { CloseCircleFilled, ShoppingCartOutlined } from '@ant-design/icons';
import { Link, useLocation } from 'react-router-dom';
import './checkoutCancelPage.scss';

const { Title, Text } = Typography;

const CheckoutCancelPage = () => {
  const location = useLocation();
  const method = location.state?.paymentMethod || 'Payment';

  return (
    <div className="checkout-cancel">
      <Card className="checkout-cancel__card">
        <CloseCircleFilled className="checkout-cancel__icon" />
        <Title level={2}>{method} was cancelled</Title>
        <Text>Your cart is unchanged. You can return to it and select another payment method.</Text>
        <Link to="/cart" className="ant-btn ant-btn-primary">
          <ShoppingCartOutlined aria-hidden="true" />
          <span>Return to cart</span>
        </Link>
      </Card>
    </div>
  );
};

export default CheckoutCancelPage;
